import MapboxDraw from "@mapbox/mapbox-gl-draw";
// import * as pdfjs from "pdfjs-dist/legacy/build/pdf";
import { RasterImage, } from "./RasterImage.class";
import { gql } from "@apollo/client";
import { CrudData } from "@catchupapplications/utilities";
import { FeatureDragger } from "./FeatureDrag.class";
import { bearing, distance, featureCollection, point, polygon, transformRotate, transformScale, transformTranslate, } from "@turf/turf";
import pinA from "../assets/pin-a.svg";
import pinB from "../assets/pin-b.svg";
const SAVE_RASTER_IMAGE = gql `
  mutation SaveRasterImage(
    $rasterImages: CrudTypeRasterImages!
    $productInstanceKey: String!
  ) {
    saveRasterImage(
      rasterImages: $rasterImages
      productInstanceKey: $productInstanceKey
    )
  }
`;
export const GET_RASTER_IMAGES = gql `
  query getRasterImages($piKey: String!, $campusKey: String!) {
    rasterImages(piKey: $piKey, campusKey: $campusKey) {
      url
      id
      campusKey
      opacity
      level
      name
      corners
      beforeId
      fileType
    }
  }
`;
class ImageManager {
    // private _appIds?: AppIds;
    // public set appIds(appIds: AppIds) {
    //   this._appIds = appIds;
    // }
    set apolloClient(value) {
        this._apolloClient = value;
    }
    set piKey(value) {
        this._piKey = value;
    }
    get currentCampusKey() {
        return this._currentCampusKey;
    }
    set currentCampusKey(value) {
        this._currentCampusKey = value;
    }
    setSelectedImage(id) {
        const image = this.crudData.get(id);
        if (image) {
            this._selectedImage = image;
        }
    }
    static getInstance(map) {
        if (!ImageManager._instance) {
            ImageManager._instance = new ImageManager(map);
        }
        return ImageManager._instance;
    }
    constructor(map) {
        this.crudData = new CrudData("images", {
            objectClass: RasterImage,
        });
        this._mapboxDraw = new MapboxDraw({
            displayControlsDefault: false,
            controls: {
                polygon: true,
                trash: true,
            },
            defaultMode: "simple_select",
        });
        this._subscribers = [];
        this.pinSourceName = "imageMapper_ab_pins";
        this.unsetDraw = () => {
            this._map.off("draw.update", this.drawUpdate);
            // @ts-ignore TODO DONT IGNORE
            if (this._map.hasControl(this._mapboxDraw))
                // @ts-ignore TODO DONT IGNORE
                this._map.removeControl(this._mapboxDraw);
        };
        this.drawUpdate = (e) => {
            if (this._selectedImage == null)
                return;
            const coordinates = e.features[0].geometry.coordinates[0];
            // this is necessary because mapbox doesnt accept more than 4 coordinates in some instances
            this._selectedImage.corners = coordinates.slice(0, 4);
            this.update();
        };
        this._map = map;
    }
    subscribe({ cb, key }) {
        this.unsubscribe(key);
        this._subscribers.push({ key, cb });
    }
    unsubscribe(key) {
        this._subscribers = this._subscribers.filter((s) => s.key !== key);
    }
    update() {
        this._subscribers.forEach((s) => s.cb());
    }
    /**
     * Show the AB Points on the map to start
     * @param start
     */
    setABPinningOnMap(start = true) {
        let pins = [];
        const setMovingListeners = () => {
            this.featureDragger = new FeatureDragger(this._map, {
                onMove: (feature) => {
                    var _a, _b;
                    if (feature) {
                        // pull out the dragging pin
                        pins = pins.filter((p) => { var _a, _b; return ((_a = p.properties) === null || _a === void 0 ? void 0 : _a.name) != ((_b = feature.properties) === null || _b === void 0 ? void 0 : _b.name); });
                        // to push the new one in
                        // @ts-ignore
                        pins.push(feature);
                        const coordinates = [
                            feature.geometry.coordinates[0],
                            feature.geometry.coordinates[1],
                        ];
                        if (((_a = feature.properties) === null || _a === void 0 ? void 0 : _a.name) === "pin-a") {
                            this.mapPointA = coordinates;
                        }
                        if (((_b = feature.properties) === null || _b === void 0 ? void 0 : _b.name) === "pin-b") {
                            this.mapPointB = coordinates;
                        }
                        const fCollection = featureCollection(pins);
                        // @ts-ignore
                        this._map.setFeatures(this.pinSourceName, fCollection);
                    }
                },
                layerId: this.pinSourceName,
            });
            this.featureDragger.setHandlerToMap();
        };
        const setInitPins = () => {
            const mapCenter = this._map.getCenter();
            this.mapPointA = [mapCenter.lng, mapCenter.lat];
            this.mapPointB = [mapCenter.lng, mapCenter.lat - 0.0005];
            const point1 = point(this.mapPointA, {
                name: "pin-a",
            });
            const point2 = point(this.mapPointB, {
                name: "pin-b",
            });
            pins.push(point1);
            pins.push(point2);
            const _featureCollection = featureCollection([point1, point2]);
            this._map.setFeatures(this.pinSourceName, _featureCollection);
        };
        const resetPins = () => {
            this._map.setFeatures(this.pinSourceName, []);
        };
        const resetMovingListeners = () => {
            var _a;
            (_a = this.featureDragger) === null || _a === void 0 ? void 0 : _a.unsetHandlerFromMap();
        };
        const setPinLayers = () => {
            const pins = [
                { name: "pin-a", imgae: pinA },
                { name: "pin-b", imgae: pinB },
            ];
            if (!this._map.getSource(this.pinSourceName)) {
                this._map.addSource(this.pinSourceName, {
                    type: "geojson",
                    data: {
                        type: "FeatureCollection",
                        features: [],
                    },
                });
            }
            pins.forEach((p) => {
                const img = new Image(134, 160);
                img.onload = () => this._map.addImage(p.name, img, { pixelRatio: 2 });
                img.src = p.imgae;
            });
            if (this._map.getLayer(this.pinSourceName)) {
                return;
            }
            // Add a symbol layer
            this._map.addLayer({
                id: this.pinSourceName,
                type: "symbol",
                source: this.pinSourceName,
                layout: {
                    "icon-image": ["get", "name"],
                    "icon-allow-overlap": true,
                    "icon-size": 0.5,
                    "icon-anchor": "bottom",
                },
            });
        };
        if (start) {
            setPinLayers();
            setMovingListeners();
            setInitPins();
        }
        else {
            resetPins();
            resetMovingListeners();
        }
    }
    movePinLayerToTop() {
        if (this._map.getLayer(this.pinSourceName)) {
            this._map.moveLayer(this.pinSourceName);
        }
    }
    /**
     * Use with AB only! Cancel the Position of the image
     */
    cancelABPinning(rasterImage) {
        rasterImage.restoreSaveState();
        this.update();
    }
    /**
     * Use with AB only! Confirm the Position of the image
     */
    confirmABPinning(rasterImage) {
        rasterImage.saveState();
        this.update();
    }
    /**
     * To be used with the ABImageMapper Component only.
  
     */
    pinRasterImageToABPoints(rasterImage, 
    /** Size of the actual HTML Image, so the coordinates have a relativity to calculate from */
    interfaceImage) {
        rasterImage.saveState();
        const sourceLayerId = "debugPolygonLayerSourceName";
        // debugging
        const setSourceAndLayer = () => {
            if (!this._map.getSource(sourceLayerId)) {
                this._map.addSource(sourceLayerId, {
                    type: "geojson",
                });
            }
            if (!this._map.getLayer(sourceLayerId)) {
                this._map.addLayer({
                    id: sourceLayerId,
                    source: sourceLayerId,
                    type: "fill",
                });
            }
        };
        const getABAdjustedImageCorners = (corners) => {
            const mapImage = {
                width: distance(corners[0], corners[1], { units: "meters" }),
                height: distance(corners[0], corners[corners.length - 1], {
                    units: "meters",
                }),
                xBearing: bearing(corners[0], corners[1]),
                yBearing: bearing(corners[0], corners[corners.length - 1]),
                a: {
                    xOffset: 0,
                    yOffset: 0,
                },
                b: {
                    xOffset: 0,
                    yOffset: 0,
                },
            };
            const relativeInterfaceImageDistance = {
                ax: interfaceImage.a[0] / interfaceImage.width,
                ay: interfaceImage.a[1] / interfaceImage.height,
                bx: interfaceImage.b[0] / interfaceImage.width,
                by: interfaceImage.b[1] / interfaceImage.height,
            };
            mapImage.a.xOffset = mapImage.width * relativeInterfaceImageDistance.ax;
            mapImage.a.yOffset = mapImage.height * relativeInterfaceImageDistance.ay;
            mapImage.b.xOffset = mapImage.width * relativeInterfaceImageDistance.bx;
            mapImage.b.yOffset = mapImage.height * relativeInterfaceImageDistance.by;
            let mapImageCornerA = [...corners[0]];
            let mapImageCornerB = [...corners[0]];
            mapImageCornerA = transformTranslate(point(mapImageCornerA), mapImage.a.xOffset, mapImage.xBearing, { units: "meters" }).geometry.coordinates;
            mapImageCornerA = transformTranslate(point(mapImageCornerA), mapImage.a.yOffset, mapImage.yBearing, { units: "meters" }).geometry.coordinates;
            mapImageCornerB = transformTranslate(point(mapImageCornerB), mapImage.b.xOffset, mapImage.xBearing, { units: "meters" }).geometry.coordinates;
            mapImageCornerB = transformTranslate(point(mapImageCornerB), mapImage.b.yOffset, mapImage.yBearing, { units: "meters" }).geometry.coordinates;
            return { mapImageCornerA, mapImageCornerB };
        };
        const getManipulatedPolygon = (cornerPolygon) => {
            if (!rasterImage.corners) {
                console.warn("RasterImage seems not to have corners", rasterImage);
                return undefined;
            }
            if (!this.mapPointA || !this.mapPointB) {
                console.error("Either MapPointA or MapPointB seem to be undefined", this.mapPointA, this.mapPointB);
                return undefined;
            }
            const { mapImageCornerA, mapImageCornerB } = getABAdjustedImageCorners(rasterImage.corners);
            const distanceImage = distance(mapImageCornerA, mapImageCornerB); // SVG
            const distanceMap = distance(this.mapPointA, this.mapPointB); // MAP
            const bearingImage = bearing(mapImageCornerA, mapImageCornerB);
            const bearingMap = bearing(this.mapPointA, this.mapPointB);
            const bearingDifference = bearingMap - bearingImage;
            const translationDirection = bearing(mapImageCornerA, this.mapPointA);
            const scaleFactor = distanceMap / distanceImage;
            const aMapAImageDistance = distance(mapImageCornerA, this.mapPointA, {
                units: "meters",
            });
            const scaledPolygon = transformScale(cornerPolygon, scaleFactor, {
                origin: mapImageCornerA,
            });
            const rotatedPolygon = transformRotate(scaledPolygon, bearingDifference, {
                pivot: mapImageCornerA,
            });
            const translatedPolygon = transformTranslate(rotatedPolygon, aMapAImageDistance, translationDirection, { units: "meters" });
            return translatedPolygon;
        };
        const getCornerPolygon = () => {
            if (!rasterImage.corners)
                return undefined;
            const corners = [...rasterImage.corners];
            // first and last position have got to be the same
            corners.push(corners[0]);
            return polygon([corners]);
        };
        const adjustRasterImageToNewPolygon = (manipulatedPolygon) => {
            const newCorners = manipulatedPolygon.geometry.coordinates[0];
            // delete the last one, as it's the same as the first one
            newCorners.pop();
            rasterImage.corners = newCorners;
        };
        // const setNewImageCoords = () => {
        //   // TODO
        // };
        setSourceAndLayer();
        const cornerPolygon = getCornerPolygon();
        // Debugging
        if (cornerPolygon) {
            const manipulatedPolygon = getManipulatedPolygon(cornerPolygon);
            if (manipulatedPolygon) {
                // this._map.setFeatures(sourceLayerId, [manipulatedPolygon]);
                adjustRasterImageToNewPolygon(manipulatedPolygon);
                this.update();
            }
        }
    }
    deleteImage(id) {
        const image = this.crudData.get(id);
        if (!image)
            return;
        this.cancelImagePositioning();
        this.crudData.delete(id);
        this.update();
    }
    // public dropFiles(acceptedFiles: Blob[], level: number) {
    //   if (this.currentCampusKey == null)
    //     throw Error(
    //       `Please provide a campusKey to the imageManager before dropping an image`
    //     );
    //   acceptedFiles.forEach((blob) => {
    //     const fileReader = new FileReader();
    //     // TODO: später noch diese abort scheiße richtig machen
    //     // reader.onabort = () => setUploadErrorText("file reading was aborted");
    //     // reader.onerror = () => setUploadErrorText("file reading has failed");
    //     fileReader.onload = () => {
    //       // Do whatever you want with the file contents
    //       switch (blob.type) {
    //         case "image/jpeg":
    //         case "image/png":
    //         case "image/jpg":
    //           this.createImage(blob, level);
    //           break;
    //         case "application/pdf":
    //           this.pdf2Image(blob, level);
    //           break;
    //         default:
    //         // setUploadErrorText($.t("fileupload.wrongFormatError"));
    //       }
    //     };
    //     fileReader.readAsArrayBuffer(blob);
    //   });
    // }
    /**
     * Initial creation from Upload
     * @param blob
     * @param level
     */
    // private createImage = (blob: Blob, level: number) => {
    //   let fileType: string;
    //   const imageURL = URL.createObjectURL(blob);
    //   const img = new Image();
    //   switch (blob.type) {
    //     case "image/jpeg":
    //       fileType = "jpeg";
    //       break;
    //     case "image/jpg":
    //       fileType = "jpg";
    //       break;
    //     case "image/png":
    //       fileType = "png";
    //       break;
    //     case "application/pdf":
    //       fileType = "pdf";
    //       break;
    //   }
    //   img.onload = () => {
    //     const fileReader = new FileReader();
    //     fileReader.onloadend = () => {
    //       if (!this.currentCampusKey)
    //         throw Error("Please provide a campusKey before dropping an image");
    //       const base64Image = fileReader.result;
    //       const height = img.height;
    //       const width = img.width;
    //       this._selectedImage = new RasterImage({
    //         id: this.crudData.getUniqueId(),
    //         imageString: base64Image as string,
    //         level: level,
    //         width: width,
    //         height: height,
    //         opacity: 1,
    //         map: this._map,
    //         campusKey: this.currentCampusKey,
    //         imageManager: this,
    //         fileType: fileType,
    //         appIds: this.appIds,
    //       });
    //       this.crudData.create(this._selectedImage);
    //       this.crudData.set(this._selectedImage.id, this._selectedImage);
    //       this._selectedImage.saveState();
    //       this.update();
    //     };
    //     fileReader.readAsDataURL(blob);
    //   };
    //   img.src = imageURL;
    // };
    // private pdf2Image(file: Blob, level: number) {
    //   pdfjs.GlobalWorkerOptions.workerSrc =
    //     "react/src/functions/helper/pdf.worker.min.js";
    //   const pdfURL = URL.createObjectURL(file);
    //   const loadingTask = pdfjs.getDocument(pdfURL);
    //   loadingTask.promise.then((pdf) => {
    //     pdf.getPage(1).then((page) => {
    //       var scale = 1.5;
    //       var viewport = page.getViewport({ scale: scale });
    //       // Canvas Erstellen für umwandlung in Bild (canvas eig für anzeigen des PDF)
    //       const canvas = document.createElement("canvas");
    //       var context = canvas.getContext("2d");
    //       canvas.classList.add("h-100", "position-absolute");
    //       canvas.style.top = "0";
    //       canvas.height = viewport.height;
    //       canvas.width = viewport.width;
    //       // Render PDF page into canvas context
    //       const renderContext = {
    //         canvasContext: context,
    //         viewport: viewport,
    //       };
    //       page.render(renderContext as RenderParameters).promise.then(() => {
    //         if (!this.currentCampusKey)
    //           throw Error("Please provide a campusKey before dropping an image");
    //         const imageDataURL = canvas.toDataURL("image/jpeg", 1);
    //         const pdfImage = new RasterImage({
    //           id: this.crudData.getUniqueId(),
    //           opacity: 1,
    //           map: this._map,
    //           imageString: imageDataURL,
    //           level: level,
    //           width: page.view[2],
    //           height: page.view[3],
    //           campusKey: this.currentCampusKey,
    //           imageManager: this,
    //           fileType: "pdf",
    //           appIds: this.appIds,
    //         });
    //         this.crudData.create(pdfImage);
    //         this.crudData.set(pdfImage.id, pdfImage);
    //       });
    //     });
    //   });
    // }
    /**
     * Upload newly added Images to the Server
     */
    async uploadImages() {
        var _a;
        if (!this._apolloClient)
            throw Error("No apollo client was assigned to the imageManager");
        if (!this._piKey)
            throw Error("Cant upload, piKey missing");
        console.log("upload", this.crudData.crudToJSON());
        const result = await this._apolloClient.mutate({
            mutation: SAVE_RASTER_IMAGE,
            variables: {
                productInstanceKey: this._piKey,
                rasterImages: this.crudData.crudToJSON(),
            },
        });
        if ((_a = result.data) === null || _a === void 0 ? void 0 : _a.saveRasterImage) {
            this.crudData.resetUserActions();
        }
        else {
            this.crudData.saveToLocalStorage();
        }
        return result;
    }
    /**
     * Setzt die initiale Collection aus den Daten der Datenbank
     */
    fromJSON(json) {
        json.forEach((object) => {
            const image = new RasterImage({
                map: this._map,
                id: object.id,
                url: object.url,
                name: object.name,
                level: object.level,
                opacity: object.opacity,
                corners: object.corners,
                campusKey: object.campusKey,
                imageManager: this,
                fileType: object.fileType,
                width: object.width,
                height: object.height,
                appIds: object.appIds,
            });
            this.crudData.set(object.id, image);
        });
    }
    /**
     * For uploading
     * @returns
     */
    toJSON() {
        const json = [];
        this.crudData.forEach((i) => {
            json.push(i.toJSON());
        });
        return json;
    }
    addImages(images) {
        images.forEach((i) => {
            this.crudData.set(i.id, i);
        });
        this.update();
    }
    // --- Functions ---
    setDraw() {
        // TODO: überprüfen ob das hier funktioniert
        this.unsetDraw();
        if (this._selectedImage == null)
            return;
        const feature = {
            type: "Feature",
            geometry: {
                type: "Polygon",
                coordinates: [
                    this._selectedImage.getCorners({ arrayEndsWithFirst: true }),
                ],
            },
        };
        // @ts-ignore TODO DONT IGNORE
        this._map.addControl(this._mapboxDraw);
        //@ts-ignore
        this._mapboxDraw.add(feature);
        this._map.on("draw.update", this.drawUpdate);
    }
    startImagePositioning(image) {
        this.unsetDraw();
        this._selectedImage = image;
        this._selectedImage.saveState();
        // @ts-ignore
        this.setDraw();
    }
    confirmImagePositioning() {
        if (this.currentCampusKey == null)
            throw Error(`Please provide a campusKey to the imageManager before applying an image. Also make sure, that it's always the latest campusKey`);
        // @ts-ignore TODO DONT IGNORE
        if (this._map.hasControl(this._mapboxDraw))
            // @ts-ignore TODO DONT IGNORE
            this._map.removeControl(this._mapboxDraw);
        if (this._selectedImage == null)
            return;
        this._selectedImage.saveState();
        this._selectedImage.campusKey = this._currentCampusKey;
        this.crudData.update(this._selectedImage);
        this.unsetDraw();
        this.update();
    }
    cancelImagePositioning() {
        if (!this._selectedImage)
            return;
        console.log("cancel");
        this._selectedImage.restoreSaveState();
        this.unsetDraw();
        this.update();
    }
}
ImageManager.allAppIds = [
    { id: "beacon-manager", name: "Beacon Manager" },
    { id: "graph", name: "Graph" },
    { id: "navi-app", name: "Navi App" },
    { id: "facility-manager", name: "Facility Manager" },
];
export default ImageManager;
